<template lang="">
	<div>
		<v-card class="d-flex justify-space-between pa-5 mb-8">
			<v-select
				v-model="status"
				placeholder="Status"
				class="b-4 h-48 py-2"
				:options="options"
        :class="'widthSize'"
			/>
			<div class="button-wrapper d-flex justify-space-between">
				<v-btn
					@click="filterList"
          :style="disabled ? 'background: var(--grey-day-030)' : 'background: var(--red)'"
          :disabled="disabled"
          outlined
          height="48"
          class="d-flex align-center mr-5"
          :class="disabled ? 'b-4' : 'b-red'"
          width="114"
				>
					<clip-loader
						v-if="loading"
						:loading="loading"
						color="#FFFFFF"
						size="22px"
					/>
					<div
            v-if="!loading"
						class="button-wrapper--text d-flex align-center justify-space-around"
						>
						<img class="pr-2" src="../../../../static/images/search.svg">
						<span style="color: var(--white)">Buscar</span>
					</div>
				</v-btn>
				<v-btn
					@click="clearForm"
          style="background: var(--white); color: var(--dark-grey)"
          outlined
          height="48"
          class="d-flex align-center b-clear"
				>
					<clip-loader
						v-if="loadingClear"
						:loading="loadingClear"
						color="var(--black)"
						size="22px"
					/>
					<div
            v-if="!loadingClear"
						class="button-wrapper--text d-flex align-center"
						>
						<img class="pr-2" src="../../../../static/images/load.svg">
						Limpar
					</div>
				</v-btn>
			</div>
		</v-card>
	</div>
</template>
<script>
// Lib
import { mapActions, mapMutations, mapState } from 'vuex'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

import VueCookies from 'vue-cookies'

export default {
	components: {
		ClipLoader
	},
  data() {
    return {
      status: null,
      disabled: true,
      options: [
        {
          value: 'true',
          text: 'Ativo',
					label: 'Ativo'
        },
        {
          value: 'false',
          text: 'Inativo',
          label: 'Inativo'
        }
      ],
    }
  },
  created() {
    this.status = null
  },
  computed: {
    ...mapState('Product', {
      loading: 'loading',
      loadingClear: 'loadingClear'
    })
  },
  methods: {
    ...mapActions('Product', [
      'getProducts'
    ]),
    ...mapMutations('Product', {
      setLoading: 'SET_LOADING',
      setFilter: 'SET_FILTER',
      setPage: 'SET_PAGE'
    }),
    async filterList () {
      this.disabled = true
      this.setLoading(true)
      this.setPage(0)
      this.setFilter(this.status.value)
      // const token = window.localStorage.getItem('authToken')
      const token = VueCookies.get('jwt-login')
      try {
        await this.getProducts({token: token})
        this.setLoading(false)
      } catch (error) {
        return error
      }
    },
    async clearForm() {
      const token = VueCookies.get('jwt-login')
      this.status = null
      this.setFilter(null)
      await this.getProducts({token: token})
      this.setLoading(false)
    }
  },
  watch: {
    'status' () {
      this.status === null ? this.disabled = true : this.disabled = false
    }
  }
}
</script>

<style lang="scss" scoped>
.b-4 {
	border: 2px solid var(--grey-day-030);
	border-radius: 4px;
}

.b-red {
  border: 2px solid var(--red)
}

.b-clear {
  border: 1px solid var(--grey-day);
}

.h-48 {
  height: 48px
}

.vs__dropdown-toggle {
	border: none !important;
}

.vs__search {
	display: flex;
  align-items: center;
  color: #7d7d7d
}

.widthSize {
  width: 420px
}

@media screen and (max-width: 1377px) {
  .widthSize {
    width: 215px;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/Contents/AutomaticsTriggers/ProductFilter.vue